import React, { useState } from "react";
import cn from "classnames";
import styles from "./Settings.module.sass";
import Dropdown from "../../../components/Dropdown";
import Checkbox from "../../../components/Checkbox";

// Options pour le tri
const sortingOptions = ["Plus récents", "Plus anciens"];

// Options pour le statut du prospect (pour les checkboxes)
const statusOptions = [
  { value: "Nouveau", label: "Nouveau" },
  { value: "En cours", label: "En cours" },
  { value: "Hors cible", label: "Hors cible" },
  { value: "Success", label: "Success" }
];

const Settings = ({ onFiltersChange }) => {
  const [sorting, setSorting] = useState(sortingOptions[0]);
  const [selectedStatuses, setSelectedStatuses] = useState([]);

  // Toggle un statut dans la liste des sélectionnés
  const handleStatusToggle = (statusValue) => {
    setSelectedStatuses(prev => {
      if (prev.includes(statusValue)) {
        return prev.filter(s => s !== statusValue);
      } else {
        return [...prev, statusValue];
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    applyFilters();
  };


  const resetFilters = () => {
    setSorting(sortingOptions[0]);
    setSelectedStatuses([]);
    if (onFiltersChange) {
      onFiltersChange({
        sorting: sortingOptions[0],
        selectedStatuses: []
      });
    }
  };

  const applyFilters = () => {
    console.log('Filtres appliqués:', {
      sorting,
      selectedStatuses
    });
    
    if (onFiltersChange) {
      onFiltersChange({
        sorting,
        selectedStatuses
      });
    }
  };

  return (
    <div className={styles.settings}>
      <div className={styles.group}>
        <div className={styles.item}>
          <Dropdown
            className={styles.dropdown}
            classDropdownLabel={styles.label}
            value={sorting}
            setValue={setSorting}
            options={sortingOptions}
            label="Trier par"
          />
        </div>
        <div className={styles.item}>
          <div className={styles.label}>Statut du prospect</div>
          <div className={styles.list}>
            {statusOptions.map((status) => (
              <Checkbox
                key={status.value}
                className={styles.checkbox}
                content={status.label}
                value={selectedStatuses.includes(status.value)}
                onChange={() => handleStatusToggle(status.value)}
                reverse
              />
            ))}
          </div>
        </div>
        <div className={styles.btns}>
          <button 
            className={cn("button-stroke", styles.button)}
            onClick={resetFilters}
          >
            Réinitialiser
          </button>
          <button 
            className={cn("button", styles.button)}
            onClick={applyFilters}
          >
            Appliquer
          </button>
        </div>
      </div>
    </div>
  );
};

export default Settings;
